import { Children, cloneElement, ComponentProps, isValidElement, PropsWithChildren } from 'react';
import { css, ClassNames } from '@emotion/react';
import { RadioCardField } from '@frontend/design-system';
import { AvailabilityFormRow } from './availability-form-row';

type Props = ComponentProps<typeof RadioCardField>;

export const RadioCardFieldRow = ({ children, ...props }: PropsWithChildren<Props>) => {
  return (
    <AvailabilityFormRow>
      <ClassNames>
        {({ css: cls, cx }) => (
          <RadioCardField {...props} css={radioCardFieldStyles}>
            {Children.toArray(children).map((child) =>
              isValidElement(child)
                ? cloneElement(child, {
                    ...child.props,
                    className: cx(
                      child.props.className,
                      cls([radioCardFieldOptionStyles, !child.props.description && titleOnlyStyles])
                    ),
                  })
                : child
            )}
          </RadioCardField>
        )}
      </ClassNames>
    </AvailabilityFormRow>
  );
};

const radioCardFieldStyles = css({
  '> div': {
    flexDirection: 'column',
  },
});

const radioCardFieldOptionStyles = css({
  '& > div:nth-of-type(2) > div > span:first-of-type': {
    width: '100%',
  },
});

const titleOnlyStyles = css({
  alignItems: 'center',
});
